import { render, staticRenderFns } from "./JoinForm.vue?vue&type=template&id=2020f8fb"
import script from "./JoinForm.vue?vue&type=script&lang=js"
export * from "./JoinForm.vue?vue&type=script&lang=js"
import style0 from "./JoinForm.vue?vue&type=style&index=0&id=2020f8fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports